import { CUSTOMER_LEVEL } from '@wyz/types';
import { useWatch } from 'react-hook-form';
import { useManageCustomers } from '~/common/api';
import { CustomerStepForms, ICustomerGeneralForm } from '~/connect/types';

export const useCustomerFormLevel = ({
  parent,
}: {
  parent: ICustomerGeneralForm['parent'];
}) => {
  const manageCustomers = useManageCustomers({
    getOneById: {
      args: { id: parent?.id?.value as string },
      enabled: Boolean(parent?.id?.value),
    },
  });
  const entityParent = manageCustomers.getOneById.data?.data;

  if (!parent?.id) {
    return CUSTOMER_LEVEL.ROOT;
  }
  if (parent.id && !entityParent) {
    return -1; // -1 means level not fetched yet
  }
  return Number(entityParent?.level) + 1;
};

export const useCustomerFormParentCustomer = ({
  methods,
}: {
  methods: CustomerStepForms['GENERAL_FORM']['methods'];
}) => {
  const watchedParentId = useWatch({
    name: 'parent.id',
    control: methods.control,
  });
  const manageCustomers = useManageCustomers({
    getOneById: {
      args: { id: String(watchedParentId?.value) },
      enabled: Boolean(watchedParentId?.value),
      gcTime: 1000 * 60 * 2, // 2mn
    },
  });

  return manageCustomers.getOneById;
};
